import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { TempElectricityRelocationPage, TempElectricityRelocationPageProps } from "./TempElectricityRelocationPage";

export const EMPTY_PAGE_CONTENT: TempElectricityRelocationPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network/temp-changes-vector";

export const TempElectricityRelocationPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<TempElectricityRelocationPageProps>(
    "electricity___temporary_relocation_or_disconnectio",
    EMPTY_PAGE_CONTENT,
  );
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <TempElectricityRelocationPage {...routeProps} {...content} />;
};
